import React from 'react';
import TermlyEmbed from './TermlyEmbed';

const ReturnPolicy = () => {
  return <TermlyEmbed dataId="f5a5bdd0-7cd2-40ed-bfa2-b28404f384ae" />;
};

export default ReturnPolicy;
